import React from 'react';

interface GhostLogoProps {
    size?: number;
    variant?: 'outline' | 'solid';
    className?: string;
}

export function GhostLogo({ size = 24, variant = 'outline', className = '' }: GhostLogoProps) {
    if (variant === 'solid') {
        return (
            <svg width={size} height={size} viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" className={className}>
                <path d="M60 15 C29 15 12 36 12 60 V104 L36 87 L60 104 L84 87 L108 104 V60 C108 36 91 15 60 15 Z" fill="#00E5FF"/>
                <rect x="43" y="56" width="7" height="7" rx="2" fill="#0A0F1C"/>
                <rect x="70" y="56" width="7" height="7" rx="2" fill="#0A0F1C"/>
            </svg>
        );
    }

    return (
        <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M60 15 C29 15 12 36 12 60 V104 L36 87 L60 104 L84 87 L108 104 V60 C108 36 91 15 60 15 Z" stroke="#00E5FF" strokeOpacity="0.12" strokeWidth="10" fill="none"/>
            <path d="M60 15 C29 15 12 36 12 60 V104 L36 87 L60 104 L84 87 L108 104 V60 C108 36 91 15 60 15 Z" stroke="#00E5FF" strokeWidth="3" strokeLinejoin="round" fill="none"/>
            <rect x="43" y="56" width="7" height="7" rx="2" fill="#00E5FF"/>
            <rect x="70" y="56" width="7" height="7" rx="2" fill="#00E5FF"/>
        </svg>
    );
}
